<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태', value: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

    <!-- 작업구분 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업구분</h5>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div v-for="checkbox in form.inspectList" :key="checkbox.id" class="flex col-span-2 items-center" style="align-self: flex-start; word-break: keep-all">
          <PrintCheckbox v-if="isPrint || board.readonly" :label="checkbox.title" :value="checkbox.check" color />
          <label v-else class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" />
            {{ checkbox.title }}
          </label>
        </div>
      </div>
    </div>

    <!-- 표 -->
    <TableInspectMerge
      v-for="inspection in form.inspectList"
      :key="`inspection_${inspection.title}`"
      v-show="inspection.check"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="inspection.title"
      tableHeaderTitle="유해·위험요인 파악"
      :tableHeaderCheck="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
      :tableHeaderNote="[{ text: '비고(개선대책)' }]"
      contentBefore="numbering"
      v-model="inspection.list"
      class="mt-28px"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="교육 사진" placeholder="신축현장 점검" />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import { required } from "vuelidate/lib/validators";
import InspectData from "./InspectData";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    FieldSelectModule,
    PhotoUploadGridModule,
    FileUploadModule,
    TableInspectMerge,
    PrintCheckbox,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inspectTitle: "",
        inspectList: JSON.parse(JSON.stringify(InspectData)),

        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        const checkData = this.form.inspectList.filter((item) => item.check);
        this.form.inspectTitle = checkData.map((item) => item.title).join(", ");

        this.$emit("input", value);
      },
    },
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) {
          alert("사업장명을 반드시 입력해야 합니다");
        }
        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
  },
};
</script>
